export default __webpack_public_path__ + "static/Cysec-cb3443f11f6ca1e9d92234a8a35b597d.png";